import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

interface ReadOnlyIdViewProps {
    idContent: string;
    idHeader: string;
    idContentStyle?: CSSProperties;
    idHeaderStyle?: CSSProperties;
    truncateText?: boolean;
    widthPerCharacter?: number;
    substituteForEmpty?: boolean;
}

const containerStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: 'transparent'
};

const defaultIdContentStyle: CSSProperties = {
    fontSize: 22,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.TEXT_VERY_DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
};

const defaultIdHeaderStyle: CSSProperties = {
    fontSize: 15,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
};

export const ReadOnlyIdView = ({
    idContent,
    idHeader,
    idContentStyle,
    idHeaderStyle,
    truncateText,
    substituteForEmpty
}: ReadOnlyIdViewProps) => {
    const emDash = '\u2014';

    let displayIdContent = idContent?.toLowerCase();
    //rule about substituting em dash for empty values like 'true', 'false', or null
    if (substituteForEmpty && (idContent === 'true' || idContent === 'false' || idContent === null || idContent === '')) {
        displayIdContent = emDash;
    }

    return (
        <div style={containerStyle}>
            <div style={{ ...defaultIdHeaderStyle, ...idHeaderStyle }} title={idHeader}>
                {idHeader}
            </div>
            <div style={{ ...defaultIdContentStyle, ...idContentStyle }} title={displayIdContent}>
                {displayIdContent}
            </div>
        </div>
    );
};
